import * as yup from 'yup'

const AdminRoleFormScheme = {
  info: yup.object().shape({
    name: yup.string().required('errors.form.empty'),
    typeUtilisateur: yup.string().oneOf(['VIPARIS', 'PRESTATAIRE', 'ORGANISATEUR'], 'errors.form.empty'),
  }),
  scope: yup.object().shape({
    scopes: yup.array(),
  }),
}

const AdminRoleFormFields: { [key in AdminRoleStep]: (keyof AdminRoleForm)[] } = {
  info: ['name', 'typeUtilisateur'],
  scope: ['scopes'],
}

export { AdminRoleFormScheme, AdminRoleFormFields }
